import { render } from "./PaymentFlowCard.vue?vue&type=template&id=be3ce0dc"
import script from "./PaymentFlowCard.vue?vue&type=script&lang=js"
export * from "./PaymentFlowCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__